module.exports = __webpack_public_path__ + "static/media/eyelotion.8d58686e.pdf";